import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ILagerplats, IMottagningsplats } from "../mottagningsplats.models";
import { MottagningsplatsDetaljerTexts } from "./mottagningsplats-detaljer.texts";

export class MottagningsplatsDetaljerPlatsValidation {

    static initHeaderSv(mottagningsplats: IMottagningsplats): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: MottagningsplatsDetaljerTexts.texts.validationNamn },
                model: () => mottagningsplats.namn,
                name: "namn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: MottagningsplatsDetaljerTexts.texts.validationMottagningsplatsTyp },
                model: () => mottagningsplats.mottagningsplatstyp,
                name: "mottagningsplatstyp",
                expression: (value) => value !== null && value !== undefined
            }
        ]);

        return context;
    }

    static initHeader(mottagningsplats: IMottagningsplats): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: MottagningsplatsDetaljerTexts.texts.validationNamn },
                model: () => mottagningsplats.namn,
                name: "namn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: MottagningsplatsDetaljerTexts.texts.validationMotagningsplatsnummer },
                model: () => mottagningsplats.mottagningsplatsnummer,
                name: "mottagningsplatsnummer",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: MottagningsplatsDetaljerTexts.texts.validationLand },
                model: () => mottagningsplats.land,
                name: "land",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                message: { text: MottagningsplatsDetaljerTexts.texts.validationMottagningsplatsTyp },
                model: () => mottagningsplats.egenTerminal,
                name: "mottagningsplatstyp",
                required: true
            }
        ]);

        return context;
    }

    static initPlats(mottagningsplats: IMottagningsplats, lagerplats: ILagerplats): ValidationContext {
        const unique = (newValue: string) => !mottagningsplats.lagerplatser.some(x => x.avlamningsplats === newValue && x !== lagerplats);
        // eslint-disable-next-line sonarjs/concise-regex
        const withinRange = (newValue: string) => /^[0-9]$/.test(newValue);

        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => !(ObjectUtils.isNullOrUndefined(newValue) || newValue.length === 0),
                message: { text: MottagningsplatsDetaljerTexts.texts.validationNamn },
                model: () => lagerplats.namn,
                name: "namn",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue: string) => unique(newValue) && (withinRange(newValue) || lagerplats.finnsIViol3),
                message: { text: "Avlastningsplats måste vara unik och mellan 0-9" },
                model: () => lagerplats.avlamningsplats,
                name: "avlamningsplats",
                required: true,
                triggerOnLoad: true,
                verbose: true
            }
        ]);

        return context;
    }
}
